module.exports = "pegasus/assets/image-1-basic.png";